import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import ViewPersonalInformation from "./personal-information/ViewPersonalInformation";
import { USERAXIOS } from "../../../../api/userAxios";
import { JobSeeker } from "../../../../types/resumes-managment/jobSeeker";
import { ResumeStatisticData } from "../../../../types/resumes-managment/resume";
import { Box } from "@mui/material";
import ResumeSkills from "./resume-skills/ResumeSkills";
import ResumeExperiences from "./resume-experiences/ResumeExperiences";
import ResumeCourses from "./resume-courses/ResumeCourses";
import ResumeLanguages from "./resume-languages/resume-courses/ResumeLanguages";
import ResumeTargetJobs from "./resume-target-jobs/ResumeTargetJobs";
import ResumeEducations from "./resume-educations/ResumeEducations";
import ResumeRecommendations from "./recommendations/ResumeRecommendations";
import ResumeMiniInterviewAnswer from "./resume-mini-interview-answer/ResumeMiniInterviewAnswer";
import ResumeAdminNotes from "./resume-admin-notes/ResumeAdminNotes";
import ResumeStatistic from "./ResumeStatistic";

const ResumeForm = () => {
  const { resumeId } = useParams();
  const [personalInfo, setPersonalInfo] = useState<JobSeeker | null>(null);
  const [resumeStatisticData, setResumeStatisticData] =
    useState<ResumeStatisticData | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!resumeId) return;
      try {
        const resumeRes = await USERAXIOS.get(`/resumes/${resumeId}`);
        const resume = resumeRes.data.data;
        if (resume && resume.profile_id) {
          const profileRes = await USERAXIOS.get(
            `/jobSeekers/${resume.profile_id}`
          );
          setPersonalInfo(profileRes.data.data);
        }
      } catch (error) {
        setPersonalInfo(null);
      }
    };
    fetchProfile();
  }, [resumeId]);

  useEffect(() => {
    const fetchResumeStatistics = async () => {
      if (!resumeId) return;
      try {
        // const response = await USERAXIOS.get(`/resumes/statistic/${resumeId}`);
        const response = await USERAXIOS.get(`/resumes/statistic/4`);

        console.log("API Response:", response.data);
        setResumeStatisticData(response.data.data);
      } catch (error) {
        console.error("Error fetching resume statistics:", error);
        setResumeStatisticData(null);
      }
    };
    fetchResumeStatistics();
  }, [resumeId]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      {resumeStatisticData && <ResumeStatistic data={resumeStatisticData} />}
      {personalInfo && (
        <ViewPersonalInformation
          personalInfo={personalInfo}
          // resumeStatisticData={resumeStatisticData}
        />
      )}
      <ResumeTargetJobs
        resumeId={Number(resumeId)}
        jobSeekerId={personalInfo?.id}
      />
      <ResumeEducations resumeId={Number(resumeId)} />
      <ResumeExperiences resumeId={Number(resumeId)} />
      <ResumeCourses resumeId={Number(resumeId)} />
      <ResumeLanguages resumeId={Number(resumeId)} />
      <ResumeRecommendations resumeId={Number(resumeId)} />
      <ResumeSkills resumeId={Number(resumeId)} />
      <ResumeAdminNotes resumeId={Number(resumeId)} />
      <ResumeMiniInterviewAnswer resumeId={Number(resumeId)} />
    </Box>
  );
};

export default ResumeForm;
